/* Temporary complete-set sizing. Keep existing variant IDs for order fulfilment. */
(() => {
  if (window.pluffiPajamasSingleSizeLoaded) return;
  window.pluffiPajamasSingleSizeLoaded = true;
  const productId = '16060325200206';
  let synchronizing = false;
  let scheduled = false;
  const root = () => document.querySelector(`variant-picker[data-product-id="${productId}"]`)?.closest('.shopify-section');
  function matchRow(row, desired) {
    const top = row.querySelector('select[data-name="Top size"]');
    const bottom = row.querySelector('select[data-name="Bottom size"]');
    if (!top || !bottom || synchronizing) return;
    const size = desired || top.value;
    if (bottom.value === size) return;
    if (![...bottom.options].some(option => option.value === size)) return;
    synchronizing = true;
    bottom.value = size;
    bottom.dispatchEvent(new Event('change', {bubbles: true}));
    top.value = size;
    synchronizing = false;
  }
  function update() {
    scheduled = false;
    const section = root();
    if (!section) return;
    section.dataset.pajamasSingleSize = '';
    section.querySelectorAll('select[data-name="Top size"]').forEach(select => {
      if (select.getAttribute('aria-label') !== 'Size') select.setAttribute('aria-label', 'Size');
    });
    section.querySelectorAll('.kaching-bundles__bar-variant-names > span').forEach(label => {
      if (label.textContent.trim() === 'Top size') label.textContent = 'Size';
    });
    section.querySelectorAll('.kaching-bundles__bar--selected .kaching-bundles__bar-variant-selects').forEach(row => matchRow(row));
    // Shopify refreshes availability asynchronously after the first option changes.
    // Select the matching bottom only once its native radio is actually available.
    const picker = section.querySelector('variant-picker');
    const nativeTop = picker?.querySelector('input[data-option-position="2"]:checked');
    const nativeBottom = picker?.querySelector('input[data-option-position="3"]:checked');
    if (nativeTop && nativeBottom && nativeTop.value !== nativeBottom.value) {
      const matching = [...picker.querySelectorAll('input[data-option-position="3"]')].find(input => input.value === nativeTop.value);
      if (matching && !matching.disabled) matching.click();
    }
    section.querySelectorAll('variant-picker fieldset[data-fieldset-index="1"] legend').forEach(legend => {
      [...legend.childNodes].filter(node => node.nodeType === Node.TEXT_NODE && node.textContent.includes('Top size')).forEach(node => {
        node.textContent = node.textContent.replace('Top size', 'Size');
      });
    });
  }
  function queueUpdate() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(update, 0);
  }
  document.addEventListener('change', event => {
    const section = root();
    const target = event.target;
    if (!section?.contains(target) || synchronizing) return;
    queueUpdate();
  }, true);
  document.addEventListener('click', event => {
    const section = root();
    if (section?.contains(event.target)) queueUpdate();
  }, true);
  new MutationObserver(queueUpdate).observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('DOMContentLoaded', update, {once: true});
  update();
})();
